import axiosInstance from '@/core/api'
import { LoginRequest, LoginResponse } from '@/modules/auth/type'

export const adminLogin = async (
	payload: LoginRequest,
): Promise<LoginResponse> => {
	const response = await axiosInstance.post<LoginResponse>(
		'/admin/auth/login',
		payload,
	)
	return response.data
}
